import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Tag as Tag$1, TagLabel, TagCloseButton } from '@chakra-ui/react';
import { TagVariant } from './types.js';
var _excluded = ["closeClick", "variant", "colorScheme", "tagLabel", "isClosable", "size", "children"];
var Tag = function Tag(_ref) {
  var closeClick = _ref.closeClick,
    _ref$variant = _ref.variant,
    variant = _ref$variant === undefined ? TagVariant.subtle : _ref$variant,
    colorScheme = _ref.colorScheme,
    tagLabel = _ref.tagLabel,
    isClosable = _ref.isClosable,
    size = _ref.size,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * DOM
   */

  return /*#__PURE__*/React.createElement(Tag$1, _extends({
    variant: variant,
    size: size,
    colorScheme: colorScheme,
    "data-object-type": "tag"
  }, rest), children, !!tagLabel && /*#__PURE__*/React.createElement(TagLabel, null), !!isClosable && /*#__PURE__*/React.createElement(TagCloseButton, {
    onClick: closeClick
  }));
};
Tag.displayName = "Tag";
export { Tag };